import { shape, string } from "prop-types";

/*
    If you change the structure in this file, you must check:
        CustomText.js and ExampleText.js

    (This will not break any component that is using
        CustomText if you just add keys)
*/

/* CustomText Data Structure Guide */
export const customDetailAccountDataStructureGuide = {
    account: shape({
        productType: string,
        idProduct: string,
        permissions: shape(),
        currency: string,
        number: string,
        ownerName: string,
        productAlias: string,
    }).isRequired,
};

export const customDetailAccountPropType = {
    account: shape({
        productType: string,
        idProduct: string,
        permissions: shape(),
        currency: string,
        number: string,
        ownerName: string,
        productAlias: string,
    }).isRequired,
};

export const defaultCustomDetailAccountPropType = {
    account: {
        productType: "",
        idProduct: "",
        permissions: {},
        currency: "",
        number: "",
        ownerName: "",
        productAlias: "",
    },
};
